module.exports = (__webpack_require__(1))(89);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-utils/object.js from dll-reference rlink_core
// module id = 24
// module chunks = 0